// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"0743757b","625":"506600a1","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};